<template>
    <div component="VideoProjectItem" :class="{ isOpen }">
        <div class="item" @click="setOpen">
            <btn size="iconSmall" :color="isOpen ? 'ghost' : 'primary'" :icon="isOpen ? 'remove' : 'add'" />
            <div class="holder">
                <div class="column first">
                    <div class="cell name">
                        <div class="label">Project:</div>
                        <span>{{ videoRequest.project.title }}</span>
                    </div>
                    <div class="cell character">
                        <div class="label">Character:</div>
                        <span>{{ videoRequest.character.meno }}</span>
                    </div>
                    <div class="cell client">
                        <div class="label">Client:</div>
                        <span>{{ videoRequest.project.client.name }}</span>
                    </div>
                </div>
                <div class="column last">
                    <div class="cell date">
                        {{ getDateWithTime(videoRequest.project.start_at) }}
                    </div>
                    <div class="cell">
                        <span class="chip" :class="getProjectStatusCSS(videoRequest.project.status)">
                            {{ videoRequest.project.status }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <transition v-on:enter="enter" v-on:leave="leave">
            <div class="detail" v-if="isOpen">
                <video-project-item-videos :emailRequest="getEmailRequest" />
                <video-project-item-text :videoRequest="videoRequest" :type="'instructions'" />
                <video-project-item-text :videoRequest="videoRequest" :type="'script'" />
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import VideoProjectItemVideo from './VideoProjectItemVideo.vue';
import VideoProjectItemVideos from '@/components/Profile/Video/Projects/VideoProjectItemVideos.vue';
import VideoProjectItemText from '@/components/Profile/Video/Projects/VideoProjectItemText.vue';

export default {
    name: 'VideoProjectItem',

    props: {
        videoRequest: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            videosOpen: true,
            instructionOpen: false,
            scriptOpen: false,
        };
    },

    computed: {
        ...mapGetters(['getActorSelectedVideoRequest']),

        isOpen() {
            return this.getActorSelectedVideoRequest === this.videoRequest.id;
        },

        getEmailRequest() {
            // Assuming that email requests are scoped by actor (have only one item)
            const [first] = this.videoRequest?.emailRequests ?? [];
            return first;
        },
    },

    methods: {
        ...mapMutations(['setActorSelectedVideoRequest']),

        enter(el, done) {
            Velocity(el, 'slideDown', { duration: 300, easing: 'easeInBack' }, { complete: done });
        },

        leave(el, done) {
            Velocity(el, 'slideUp', { duration: 300, easing: 'easeInBack' }, { complete: done });
        },

        getDateWithTime(date) {
            return `${moment(date).format('DD. MM. YYYY')}`;
        },

        setOpen() {
            const id = this.isOpen ? null : this.videoRequest.id;
            this.setActorSelectedVideoRequest(id);
        },

        getProjectStatusCSS(state) {
            switch (state) {
                case 'CLOSED':
                    return 'closed';
                case 'IN PROGRESS':
                    return 'progress';
                case 'SENT':
                    return 'sent';
                case 'APPROVED':
                    return 'approved';
                default:
                    return '';
            }
        },
    },

    components: { VideoProjectItemText, VideoProjectItemVideos, VideoProjectItemVideo },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='VideoProjectItem'] {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    overflow: hidden;
    transition: 0.5s;
    margin-right: 15px;
    margin-bottom: 10px;
    .gradientListItem;
    .radius;
    .border;

    &.isOpen {
        background: linear-gradient(0deg, #ffffff 0%, #ffffff 100%);

        .item {
            border-color: @border;
        }
    }

    &:hover {
        background: linear-gradient(0deg, #ffffff 0%, #ffffff 100%);
    }

    .item {
        display: flex;
        align-items: center;
        transition: 0.5s;
        padding: 10px;
        border-bottom: 1px solid transparent;

        .holder {
            display: flex;
            align-items: center;
            width: 100%;
            padding-left: 10px;

            @media (max-width: 460px) {
                flex-direction: column;
            }
        }

        .column {
            .flex-column;

            @media (max-width: 460px) {
                width: 100%;
            }

            &.first {
                flex: 1;
                padding-right: 15px;
            }

            &.last {
                align-items: flex-end;

                @media (max-width: 460px) {
                    margin-top: 5px;
                    align-items: flex-start;
                }
            }

            .cell {
                .flex-row;
                font-size: 13px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                .label {
                    min-width: 65px;
                }

                &.name span {
                    font-weight: 900;
                }
            }
        }
    }

    .detail {
        .accordion {
            padding: 5px 0;
            .border-b;

            &:last-child {
                border-width: 0;
            }

            header {
                display: flex;
                align-items: center;
                font-weight: 900;
                cursor: pointer;

                button {
                    margin-right: 5px;
                }
            }

            footer {
                padding: 0 0 10px 30px;
            }
        }
    }

    .chip {
        font-size: 9px;
        font-weight: normal;
        padding: 2px 5px;
        border-radius: 10px;
        border: 1px solid transparent;

        &.closed {
            color: rgba(0, 0, 0, 0.5);
            border-color: rgba(0, 0, 0, 0.3);
        }

        &.progress {
            color: white;
            background: @color_green !important;
        }

        &.sent {
            color: white;
            background: @color_orange !important;
        }

        &.approved {
            color: white;
            background: @color_blue !important;
        }
    }
}
</style>
